import { t } from '@lingui/macro';

import { ApiKeyResource, ApiKeyServerStatus } from '@api/v4/organizations/api_keys';

import { ApiKeyRow, ApiKeyStatus } from './types';

/** Maps the server status enum onto the three chip states used by the UI. */
export const mapApiKeyStatus = (status: ApiKeyServerStatus): ApiKeyStatus => {
  switch (status) {
    case 'expiring_soon':
      return 'expiring';
    case 'deactivated':
    case 'revoked':
      return 'disabled';
    case 'active':
    default:
      return 'active';
  }
};

/** Maps an api_key JSON:API resource from the server onto the table row shape. */
export const mapApiKey = ({ attributes, id }: ApiKeyResource): ApiKeyRow => ({
  createdAt: attributes.created_at,
  createdBy: attributes.created_by_user?.name ?? '',
  description: attributes.description ?? '',
  expiresAt: attributes.expires_at,
  id,
  name: attributes.name,
  rotatedFromTokenPrefix: attributes.rotated_from?.token_prefix ?? null,
  source: attributes.source,
  status: mapApiKeyStatus(attributes.status),
  tokenPrefix: attributes.token_prefix,
});

export const statusLabel = (status: ApiKeyStatus): string => {
  switch (status) {
    case 'expiring':
      return t`Expiring Soon`;
    case 'disabled':
      return t`Disabled`;
    case 'active':
    default:
      return t`Active`;
  }
};

/** Formats an ISO timestamp as MM/DD/YYYY. Returns empty string for null/invalid dates. */
export const formatDate = (isoDate: string | null | undefined): string => {
  if (!isoDate) return '';
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const day = `${date.getDate()}`.padStart(2, '0');
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};
